import React, { useRef } from 'react'

const MagneticButton = ({ children, className, href, style, onClick, target, rel }) => {
	const ref = useRef(null)

	const handleMouseMove = (e) => {
		if (!ref.current) return
		const rect = ref.current.getBoundingClientRect()
		const x = (e.clientX - rect.left - rect.width / 2) * 0.38
		const y = (e.clientY - rect.top - rect.height / 2) * 0.38
		ref.current.style.transform = `translate(${x}px, ${y}px)`
		ref.current.style.transition = 'transform 0.08s ease'
	}

	const handleMouseLeave = () => {
		if (!ref.current) return
		ref.current.style.transform = 'translate(0px, 0px)'
		ref.current.style.transition = 'transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)'
	}

	if (href) {
		return (
			<a
				ref={ref}
				href={href}
				className={className}
				style={style}
				target={target}
				rel={rel}
				onMouseMove={handleMouseMove}
				onMouseLeave={handleMouseLeave}>
				{children}
			</a>
		)
	}

	return (
		<button
			ref={ref}
			className={className}
			style={style}
			onClick={onClick}
			onMouseMove={handleMouseMove}
			onMouseLeave={handleMouseLeave}>
			{children}
		</button>
	)
}

export default MagneticButton
